import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "22", x2: "2", y1: "6", y2: "6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "22", x2: "2", y1: "18", y2: "18", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "6", x2: "6", y1: "2", y2: "22", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "18", x2: "18", y1: "2", y2: "22", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Frame";
const Frame = memo(themed(Icon));
export {
  Frame
};
//# sourceMappingURL=frame.js.map
